import { atom } from "../app-jotai";

import type {
  ICurrentUserMetadata,
  IParticipant,
} from "./host_listener/types/participant";
import type { IRoomMetadata } from "./host_listener/types/room";

// import type { ICurrentUserMetadata } from "./host_listener/types/room";

export const themeAtom = atom<"light" | "dark">("light");
export const userinfoAtom = atom<IParticipant>({
  name: "",
  sid: "",
  userId: "",
  metadata: {
    is_admin: false,
    is_presenter: false,
    lock_settings: {
      lock_draw_on_whiteboard: false,
    },
  },
} as IParticipant);

// Derived atom to get/set only the metadata portion
export const userMetadataAtom = atom(
  (get) => get(userinfoAtom).metadata,
  (get, set, newMetadata: ICurrentUserMetadata) => {
    const currentUserInfo = get(userinfoAtom);
    set(userinfoAtom, {
      ...currentUserInfo,
      metadata: newMetadata,
    });
  },
);
export const userRoleAtom = atom((get) => ({
  isAdmin: get(userinfoAtom).metadata.is_admin,
  isPresenter: get(userinfoAtom).metadata.is_presenter,
}));
export const roomMetadataAtom = atom<IRoomMetadata>({
  room_title: "",
  default_lock_settings: {
    lock_draw_on_whiteboard: false,
  },
  room_features: {
    whiteboard_features: {
      allowed_whiteboard: true,
      file_name: "",
      file_path: "",
      total_pages: 0,
      whiteboard_file_id: "",
      visible: true,
      preload_file: "",
    },
  },
} as IRoomMetadata);
